/**
 * @file input组件
 * @author (zhaojun10)
 */
import Input from './Input.js';
import MiniInput from './MiniInput.js';
export { MiniInput };
export default Input;